import * as React from "react";
import type { SummaryCardsProps } from "@wayflyer/flyui";
import { MarkDown, SummaryCards } from "@wayflyer/flyui";
import type { LegacyTableProps, ReferencedStackedLineChartProps, ChartFiltersProps } from "@wayflyer/flyui-dataviz";
import { ReferencedStackedLineChart, ChartFilters } from "@wayflyer/flyui-dataviz";

import { InsightsDataTable } from "../../../components/insights-data-table";
import { TabTitle } from "../../../components/tab-title";
import type { GenericAdsPerformanceTableProps } from "../generic-ads-performance-table";
import { GenericAdsPerformanceTable } from "../generic-ads-performance-table";
import type { NotesProps } from "../../../components/notes";
import { Notes } from "../../../components/notes";

export interface GenericAdsTabProps {
  title: string;
  chartData?: ReferencedStackedLineChartProps;
  chartFilters?: ChartFiltersProps;
  summaryCards?: SummaryCardsProps;
  summaryTable?: LegacyTableProps;
  performanceTableData?: GenericAdsPerformanceTableProps;
  tooltip?: string;
  details?: string;
  notes?: NotesProps;
}

/**
 * GenericAdsTab component
 */
export const GenericAdsTab = ({
  title,
  summaryTable,
  summaryCards,
  chartData,
  performanceTableData,
  tooltip,
  chartFilters,
  details,
  notes,
}: GenericAdsTabProps) => {
  return (
    <>
      <TabTitle title={title} tooltip={tooltip} />
      {summaryTable ? <InsightsDataTable {...summaryTable} /> : null}
      {summaryCards ? <SummaryCards {...summaryCards} /> : null}
      {chartData ? <ReferencedStackedLineChart {...chartData} /> : null}
      {chartFilters ? <ChartFilters {...chartFilters} /> : null}
      {performanceTableData ? <GenericAdsPerformanceTable {...performanceTableData} /> : null}
      {details ? <MarkDown markdown={details} /> : null}
      {notes ? <Notes {...notes} /> : null}
    </>
  );
};
